export const TOKEN_NAME = 'nebula_token';
export const USER_ITEM_NAME = 'nebula_user';
export const LANG_NAME = 'nebula_lang';
export const CART_DATA = 'nebula_cart';
export const TOKEN_PREFIX = 'Bearer ';
export const MAX_UPLOAD_SIZE = 307200; // 300KB
export const LANGUAGES = ['pl', 'en']; // must be exactly two lowercase letters
export const GOOGLE_GEOCODE_API_KEY = "AIzaSyAPrLzn6_DfPf_SHGOfQEA3XYIOi1UkH5s";
export const GOOGLE_MAPS_API_KEY = "AIzaSyByVeSfuP4Trp7a8FqmuWknFKaziOYjUlM";

/*eslint-disable*/
export const FORM_TEXTS = {
  required: {
    pl: "To pole jest wymagane",
    en: "This field is required",
  },
  confirm_password: {
    pl: "Hasła nie są identyczne",
    en: "These passwords are not equal",
  },
  password_min: {
    pl: "Hasło powinno mieć co najmniej ${min} znaków",
    en: "Password should have at least ${min} signs",
  },
  min: {
    pl: "To pole powinno mieć co najmniej ${min} znaków",
    en: "This field should have at least ${min} signs",
  },
  max: {
    pl: "To pole nie może mieć więcej niż ${max} znaków",
    en: "This field should have no more than ${max} signs",
  },
  email: {
    pl: "Adres email nie jest poprawny",
    en: "Email address is not valid"
  },
  exact(number) { return {
    pl: `To pole musie mieć dokładnie ${number} znaków`,
    en: `That field must have exactly ${number} signs`,
  }},
  invalid_format: {
    pl: "To pole ma nieprawidłowy format",
    en: "This field format is invalid",
  },
};


// WEBPACK FOOTER //
// ./src/CONSTANTS.js